(function () {
    'use-strict';

    var input = document.getElementById("meilisearch-input");
    var resultsContainer = document.getElementById("ms-search-results");
    var wrapper = input && input.closest('[data-ms-search]');
    var searchIcon = wrapper && wrapper.querySelector('.ms-search__icon--search');
    var clearButton = wrapper && wrapper.querySelector('[data-search-clear]');

    var config = window.MeilisearchPredictiveConfig || {};
    if (!config || !input || !resultsContainer) return;

    function setIconState(isOpen) {
        if (searchIcon) searchIcon.hidden = isOpen;
        if (clearButton) clearButton.hidden = !isOpen;
    }

    var backdrop = null;
    function setSearchActive(open) {
        if (open && !backdrop) {
            backdrop = document.createElement('div');
            backdrop.className = 'ms-search-backdrop';
            backdrop.addEventListener('click', closeDropdown);
            document.body.appendChild(backdrop);
        }
        document.body.classList.toggle('ms-search-active', open);
    }

    var HOST = config.host;
    var API_KEY = config.apiKey;
    var INDEX = config.index;
    var showOutOfStock = config.showOutOfStock !== false;
    var locale = config.locale || 'de';
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var debounceTimer = null;
    var abortController = null;

    var PREDICTIVE_SRCSET_WIDTHS = [120, 240, 360];

    function closeDropdown() {
        resultsContainer.hidden = true;
        resultsContainer.innerHTML = '';
        clearTimeout(debounceTimer);
        if (abortController) abortController.abort();
        setIconState(false);
        setSearchActive(false);
    }

    input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var query = input.value.trim();

        if (!query) {
            closeDropdown();
            return;
        }

        setIconState(true);

        debounceTimer = setTimeout(function () {
            startSearch(query);
        }, 300);
    });

    if (clearButton) {
        clearButton.addEventListener('click', function () {
            input.value = '';
            closeDropdown();
            input.focus();
        });
    }

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            var query = input.value.trim();
            if (query) {
                window.location.href = rootPath + 'search?q=' + encodeURIComponent(query);
            }
        } else if (e.key === 'Escape') {
            closeDropdown();
            input.blur();
        }
    });

    function startSearch(query) {
        if (abortController) abortController.abort();
        abortController = new AbortController();

        var searchQuery = { indexUid: INDEX, q: query, limit: 10 };
        if (!showOutOfStock) {
            searchQuery.filter = '(variants.sellableOnlineQuantity > 0 OR variants.inventoryPolicy = "CONTINUE")';
        }

        fetch(HOST + "/multi-search", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + API_KEY
            },
            body: JSON.stringify({ queries: [searchQuery] }),
            signal: abortController.signal
        })
            .then(response => {
                if (!response.ok) throw new Error('Meilisearch ' + response.status);
                return response.json();
            })
            .then(data => {
                var hits = data.results && data.results[0] ? data.results[0].hits : [];
                renderResults(hits);
            })
            .catch(error => {
                if (error.name !== 'AbortError') {
                    console.error("Error searching for products: ", error);
                }
            });
    }

    function renderResults(hits) {
        setIconState(true);

        var productsHeader = config.productsHeader || 'Produkte';
        var viewAllMessage = config.viewAllMessage || 'Weitere Produkte';

        var body;
        if (!hits.length) {
            // Keep the header, show the empty-state text instead of cards
            body = '<div class="ms-predictive-empty">' + (config.noResultsMessage || 'Keine Ergebnisse gefunden.') + '</div>';
        } else {
            body = `
                <div class="ms-predictive-hits">${hits.map(renderHit).join('')}</div>
                <div class="ms-view-all">
                    <a href="${rootPath}search?q=${encodeURIComponent(input.value.trim())}">${viewAllMessage}</a>
                </div>
            `;
        }

        resultsContainer.innerHTML = `
            <div class="ms-products-results">
                <div class="ms-section-header">${productsHeader}</div>
                ${body}
            </div>
        `;
        resultsContainer.hidden = false;
        setSearchActive(true);
    }

    function shopifyImageUrl(src, width) {
        if (!src) return src;
        var sep = src.indexOf('?') !== -1 ? '&' : '?';
        return src + sep + 'width=' + width;
    }

    function shopifySrcset(src) {
        if (!src) return '';
        return PREDICTIVE_SRCSET_WIDTHS
            .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
            .join(', ');
    }

    function getImageSrc(hit) {
        if (hit.images && hit.images.length) {
            var img = hit.images[0];
            var src = typeof img === 'string' ? img : (img.src || img.url || '');
            return src || '';
        }

        return '';
    }

    function getTitle(hit) {
        if (locale && locale !== 'de') {
            var localized = hit['title_' + locale];
            if (localized) return localized;
        }

        return hit.title || 'Produkt';
    }

    function getHandle(hit) {
        const localizedHandle = hit['handle_' + locale] || hit.handle || '';
        return rootPath + 'products/' + localizedHandle;
    }

    function getPriceMarkup(hit) {
        var price = null;
        var compareAtPrice = null;
        var hasMultipleVariants = hit.variants && hit.variants.length > 1;

        if (!hit.variants || !hit.variants.length) {
            price = (hit.price && parseFloat(hit.price.minPrice)) || 0;
        } else {
            var minVariant = hit.variants.reduce(function (min, v) {
                var vPrice = parseFloat(v.price);
                var minPrice = parseFloat(min.price);
                if (isNaN(vPrice)) return min;
                if (isNaN(minPrice)) return v;
                return vPrice < minPrice ? v : min;
            });

            price = (minVariant && minVariant.price && parseFloat(minVariant.price)) || 0;
            compareAtPrice = (minVariant && minVariant.compareAtPrice && parseFloat(minVariant.compareAtPrice)) || 0;
        }

        return `
            ${hasMultipleVariants ? '<span class="ms-price-from">' + (config.fromMessage || 'from') + ' </span>' : ''}
            <span class="ms-price">${price.toFixed(2)} ${hit.price && hit.price.currency ? hit.price.currency : 'CHF'}</span>
            ${compareAtPrice && compareAtPrice > price ? '<span class="ms-compare-at">' + compareAtPrice.toFixed(2) + ' ' + (hit.price && hit.price.currency ? hit.price.currency : 'CHF') + '</span>' : ''}
        `;
    }

    function renderHit(hit) {
        var handle = getHandle(hit);
        var title = getTitle(hit);
        var imgSrc = getImageSrc(hit);

        return `
            <a href="${handle}" class="ms-predictive-hit">
                <div class="ms-hit-image">
                    ${imgSrc ? `<img src="${shopifyImageUrl(imgSrc, 120)}" srcset="${shopifySrcset(imgSrc)}" sizes="60px" alt="${title}" loading="lazy">` : '<img src="https://aico.apps.aico.swiss/images/no-images.png" alt="' + title + '" loading="lazy">'}
                </div>

                <div class="ms-hit-info">
                    <div class="ms-hit-title">${title}</div>
                    <div class="ms-hit-category"></div>
                    <div class="ms-hit-price">${getPriceMarkup(hit)}</div>
                </div>
            </a>
        `;
    }
}());